<template>
    <div>
        <p class="mb-1">{{ luxonDateTimeInZone | toTimeString }}</p>
        <p class="mb-1 small">{{ luxonDateTimeInZone | toDateString }}</p>
        <p class="mb-1 small text-muted">{{ luxonDateTimeInZone | toTimeZoneOffsetName }}</p>
    </div>
</template>

<script>
import { DateTime } from 'luxon';

export default {
    name: 'TimeZoneClock',
    components: {},
    props: {
        ianaZone: {
            type: String,
            required: true,
        }
    },
    data: function() {
        return {
            currentLocalTime: null,
            theClock: null,  // we'll put the timer / clock function here in mounted hook
            updateInterval: 60000,  // time in ms
        }
    },
    computed: {
        luxonDateTimeInZone: function() {
            // returns a luxon DateTime object... have to do something with it
            return this.currentLocalTime ? this.currentLocalTime.setZone(this.ianaZone) : null;  // luxon DateTime object of current time in that zone
        },
    },
    filters: {
        toTimeString: function(luxonObj) {
            // value should be a luxon DateTime object -- returns Time in '1:30 PM' / TIME_SIMPLE format
            // could also use TIME_WITH_SECONDS 
            if (!luxonObj) return '';
            return luxonObj.toLocaleString(DateTime.TIME_SIMPLE);
        },
        toDateString: function(luxonObj) {
            // value should be a luxon DateTime object -- returns Date in 'Fri, Oct 14, 1983' / DATE_MED_WITH_WEEKDAY format
            // could also use DATE_HUGE for 'Tuesday, October 14, 1983'
            // or .toFormat("EEEE',' MMMM d")  for 'Tuesday, October 6'
            if (!luxonObj) return '';
            return luxonObj.toFormat("EEEE', 'MMMM d");
        },
        toTimeZoneOffsetName: function(luxonObj) {
            // returns something like 'Eastern Standard Time'
            if (!luxonObj) return '';
            return luxonObj.toFormat('ZZZZZ');
        },
    },
    mounted: function() {
        this.updateTime();  // do this once, then setInterval will take over
        this.theClock = setInterval(this.updateTime, this.updateInterval); 
        // for reference:  https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Asynchronous/Timeouts_and_intervals
    },
    methods: {
        updateTime: function() {
            this.currentLocalTime = DateTime.local();
        },
        luxonToString: function(luxonObj) {
            if (!luxonObj) return '';
            return luxonObj.toString();
        },
    }
}
</script>

<style>

</style>